import { StartupService } from "../services/startup.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { DayPilotModule } from "daypilot-pro-angular";
import { HttpClientModule } from "@angular/common/http";
import { MaterialModule } from '.././shared/material.module';
import { DirectivesModule } from "../directives/directives.module";
import { ReportsComponent } from "./reports.component";
import { InvoicesComponent } from './invoices/invoices.component';
import { HistoricalComponent } from './historical/historical.component';
import { FlightComponent } from './flight/flight.component';
import { CheckInReportComponent } from './checkIn/checkIn-report.component';
import { TransferComponent } from './transfer/transfer.component';
import { TransferSummaryComponent } from './transferSummary/transferSummary.component';
import { DriverComponent } from './driver/driver.component';
import { AgGridModule } from 'ag-grid-angular';
import { ChartsModule } from 'ng2-charts';
import { NgxSpinnerModule } from '@hardpool/ngx-spinner';
import { DriverReportDetailsComponent } from "./driver/driver-report-details/driver-report-details.component";


@NgModule({
  imports: [
    BrowserModule,
    AgGridModule,
    BrowserAnimationsModule,
    FormsModule,
    ChartsModule,
    HttpClientModule,
    CommonModule,
    DayPilotModule,
    NgxSpinnerModule,
    MaterialModule,
    ReactiveFormsModule,
    DirectivesModule
  ],
  declarations: [
    ReportsComponent,
    InvoicesComponent,
    HistoricalComponent,
    FlightComponent,
    TransferComponent,
    TransferSummaryComponent,
    DriverComponent,
    DriverReportDetailsComponent,
    CheckInReportComponent
  ],
  exports: [ReportsComponent],
  providers: [StartupService]
})
export class ReportsModule { }
